import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import NotificationBell from "@/components/NotificationBell";
import { Palmtree, LogOut } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

const ROLE_LABEL = { admin: "Admin Command", pm: "PM Portal", vendor: "Vendor Field" };

export default function DashboardShell({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const home = user?.role === "admin" ? "/admin" : user?.role === "pm" ? "/pm" : "/vendor";

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <header className="glass border-b border-white/10 sticky top-0 z-40">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to={home} className="flex items-center gap-2.5">
            <div className="w-9 h-9 rounded-lg bg-sunburst flex items-center justify-center">
              <Palmtree className="w-5 h-5 text-white" />
            </div>
            <div className="leading-tight">
              <p className="text-white font-display font-bold text-sm">Florida Property Assistants</p>
              <p className="text-white/50 text-[11px] font-mono uppercase tracking-widest">{ROLE_LABEL[user?.role]}</p>
            </div>
          </Link>
          <div className="flex items-center gap-2">
            <NotificationBell />
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button data-testid="user-menu" className="flex items-center gap-2 pl-2 pr-3 py-1.5 rounded-lg hover:bg-white/10 transition-colors">
                  <div className="w-8 h-8 rounded-full bg-ocean flex items-center justify-center text-white font-semibold text-sm">
                    {user?.name?.[0]?.toUpperCase()}
                  </div>
                  <span className="text-white/90 text-sm font-medium hidden sm:block">{user?.name}</span>
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-52">
                <div className="px-3 py-2">
                  <p className="text-sm font-semibold text-slate-800">{user?.name}</p>
                  <p className="text-xs text-slate-400">{user?.email}</p>
                </div>
                <DropdownMenuSeparator />
                <DropdownMenuItem data-testid="logout-button" onClick={() => { logout(); navigate("/"); }} className="text-red-600 cursor-pointer">
                  <LogOut className="w-4 h-4 mr-2" /> Sign out
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </div>
      </header>
      <main className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-8">{children}</main>
    </div>
  );
}
